import React, { useEffect, useState } from 'react';

import Grid from '@wui/layout/grid';
import Typography from '@wui/basics/typography';
import Table from '@wui/layout/table';
import CustomIcon from '@wui/basics/customIcon';

import { API } from 'API';
import { useGlobalContext } from 'hooks';
import { getSectionText } from 'utils';
import { DocumentBundle } from 'utils/enums';

import { ReactComponent as GreenTickIcon } from '@a/images/green-tick.svg';

const rowFor = doc => ({
  alignItems: 'center',
  content: [
    <Typography key="1">{doc.display_name}</Typography>,

    <Grid key="2" container spacing={1} alignItems="flex-start">
      <Grid item>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item>
            <CustomIcon src={GreenTickIcon} />
          </Grid>
          <Grid item>
            <Typography variant="body1" style={{ color: '#2EA692' }}>
              Complete
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>,
  ],
});

const tableFor = (section, clientData) => (
  <Table
    key={section.display_name}
    rows={section.documents.map(rowFor)}
    columns={[
      { title: getSectionText(section.section_type, clientData), xs: 7 },
      { title: 'Status', xs: 5 },
    ]}
  />
);

const AnalogDocumentList = () => {
  const { clientData } = useGlobalContext();
  const [sections, setSections] = useState([]);

  useEffect(() => {
    API.getDocumentsInfo(DocumentBundle.HOMEOWNERS).then(res => setSections(res.sections));
  }, [setSections]);

  return sections.map(section => tableFor(section, clientData));
};

export default AnalogDocumentList;
